import avatarFace from '@Assets/images/avatar-face.png';

interface UserAvatarProps {
  /** Pixel diameter of the round avatar. */
  size?: number;
  className?: string;
}

/**
 * Round profile avatar matching the MobileApp `Avatar` (pineapple face).
 * The source image is larger than the circle and offset so the face is
 * centered — same crop ratios as MobileApp/components/profile/Avatar.tsx.
 */
export const UserAvatar = ({ size = 37, className = '' }: UserAvatarProps) => {
  const imgSize = size * 1.595;
  const offsetTop = -size * 0.3735;
  const offsetLeft = -size * 0.2914;

  return (
    <span
      className={`relative inline-block overflow-hidden rounded-full ${className}`}
      style={{ width: size, height: size }}
      role="img"
      aria-label="Profile avatar"
    >
      <img
        src={avatarFace}
        alt=""
        aria-hidden="true"
        className="absolute max-w-none"
        style={{
          width: imgSize,
          height: imgSize,
          top: offsetTop,
          left: offsetLeft,
        }}
      />
    </span>
  );
};
